import { style } from '@vanilla-extract/css'

export const subtitle = style({
  fontSize: '18px',
  fontWeight: '700',
  textAlign: 'center',
  lineHeight: '1.5',
  wordBreak: 'keep-all',
})

export const description = style({
  fontSize: '13px',
  lineHeight: '1.5',
  textAlign: 'center',
  color: '#828282',
})

export const grid = style({
  display: 'grid',
  gridTemplateColumns: 'repeat(3, 1fr)',
  gap: '16px',
  width: '100%',
})
